import {Component, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {AuxiliarService} from './services/auxiliar.service';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ThemeService} from './services/theme.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import {environment} from '../environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public auxiliarService: AuxiliarService, private messageService: MessageService,
              private primeNGConfig: PrimeNGConfig, private translate: TranslateService,
              private themeService: ThemeService, private titleService: Title) {
    // observable to trigger toast
    this.auxiliarService.toastObservable.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (_.get(value, 'message')) {
        this.messageService.add({
          severity: _.get(value, 'type', 'info'),
          summary: _.get(value, 'message'),
          key: 'toast',
          life: 5000
        });
      }
    });
    // prime translations
    this.translate.stream('primeng').subscribe(data => {
      this.primeNGConfig.setTranslation(data);
    });
    // moment locale (spanish)
    moment.locale('es');
  }

  ngOnInit(): void {
    // set navigator title
    switch (environment.company) {
      case 'bs':
        this.titleService.setTitle('BlancoSil');
        break;
      case 'ts':
        this.titleService.setTitle('Talento Solutions');
        break;
      default:
        this.titleService.setTitle('TH');
    }
    // set palette
    this.themeService.setPalette(`${environment.company}-palette`);
    // set company theme light
    this.themeService.switchTheme(`${environment.company}-light-theme`);
  }
}
